import { render, staticRenderFns } from "./ArrowBtnBlue.vue?vue&type=template&id=651a6ff1&scoped=true&lang=pug"
import script from "./ArrowBtnBlue.vue?vue&type=script&lang=js"
export * from "./ArrowBtnBlue.vue?vue&type=script&lang=js"
import style0 from "./ArrowBtnBlue.vue?vue&type=style&index=0&id=651a6ff1&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "651a6ff1",
  null
  
)

export default component.exports